/* eslint-disable local-rules/no-hardcoded-id-in-svg */
import React from 'react'
import { G, Path, Defs, LinearGradient, Stop } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'

import { AccessibleIcon } from '../../types'

function FirstMuseumBookingUnlockedSvg({ size, accessibilityLabel, testID }: AccessibleIcon) {
  return (
    <AccessibleSvg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M83.5601 76.664C83.5601 76.664 52.1652 89.087 49.3505 89.087C46.5358 89.087 15.0683 76.7899 15.0683 76.7899C13.6937 76.7919 13.6202 23.9074 14.9958 23.9054C14.9958 23.9054 47.425 10 49.3515 10C51.278 10 83.4886 23.7795 83.4886 23.7795C84.12 23.7795 84.1925 76.663 83.5611 76.664H83.5601Z"
          fill="url(#paint0_linear_8631_20754)"
        />
        <Path
          d="M49.3516 89.088C52.1663 89.088 83.5612 76.665 83.5612 76.665C84.1926 76.665 84.1201 23.7795 83.4887 23.7805C83.4887 23.7805 51.2781 10.001 49.3516 10.001V89.089V89.088Z"
          fill="url(#paint1_linear_8631_20754)"
        />
        <Path
          d="M82.2512 25.7473C82.2512 25.7473 51.1956 12.3686 49.3386 12.3686C47.4816 12.3686 16.2146 25.8692 16.2146 25.8692C14.8883 25.8712 14.9588 77.2148 16.2851 77.2128C16.2851 77.2128 46.6246 89.1515 49.3386 89.1515C52.0526 89.1515 82.3216 77.09 82.3216 77.09C82.9299 77.09 82.8604 25.7453 82.2512 25.7463V25.7473ZM79.5613 74.9298C79.5613 74.9298 51.829 85.9802 49.3426 85.9802C46.8562 85.9802 19.0595 75.0416 19.0595 75.0416C17.845 75.0436 17.7805 28.0021 18.995 28.0011C18.995 28.0011 47.6417 15.6325 49.3426 15.6325C51.0435 15.6325 79.4969 27.8893 79.4969 27.8893C80.0548 27.8893 80.1192 74.9298 79.5613 74.9298Z"
          fill="#BCB6C3"
        />
        <Path
          d="M83.488 23.7795C83.488 23.7795 51.2773 10 49.3518 10C47.4263 10 14.9962 23.9054 14.9962 23.9054C13.6215 23.9074 13.694 76.7919 15.0687 76.7899C15.0687 76.7899 46.5361 89.087 49.3508 89.087C52.1655 89.087 83.5605 76.664 83.5605 76.664C84.1919 76.664 84.1194 23.7785 83.488 23.7795ZM80.6974 74.4384C80.6974 74.4384 51.9339 85.8211 49.3548 85.8211C46.7758 85.8211 17.9458 74.5542 17.9458 74.5542C16.686 74.5562 16.6195 26.1038 17.8794 26.1018C17.8794 26.1018 47.5905 13.3615 49.3548 13.3615C51.1192 13.3615 80.6309 25.986 80.6309 25.986C81.209 25.986 81.2765 74.4374 80.6974 74.4384Z"
          fill="url(#paint2_linear_8631_20754)"
        />
        <Path
          d="M23.0935 30.6778V71.2964C23.0935 71.3195 23.1076 71.3407 23.1277 71.3498L41.5901 79.4283C41.7754 79.5099 41.9385 79.2763 41.7975 79.1303L29.4269 66.2692C29.4188 66.2611 29.4138 66.25 29.4118 66.239L23.2093 30.6678C23.1972 30.5983 23.0945 30.6063 23.0945 30.6778H23.0935Z"
          fill="#E3DEED"
        />
        <Path
          d="M74.3811 30.6778V71.2964C74.3811 71.3195 74.367 71.3407 74.3468 71.3498L55.8845 79.4283C55.6992 79.5099 55.5361 79.2763 55.677 79.1303L68.0477 66.2692C68.0558 66.2611 68.0608 66.25 68.0628 66.239L74.2652 30.6678C74.2773 30.5983 74.3801 30.6063 74.3801 30.6778H74.3811Z"
          fill="#EFEEF0"
        />
        <Path
          d="M91.722 56.1852C91.4836 56.0277 86.4963 56.3718 85.743 56.293C85.6524 56.3511 85.6572 57.1016 85.681 57.2467H91.9032C91.9461 56.9979 91.9794 56.3552 91.722 56.1852Z"
          fill="#7F8AA5"
        />
        <Path
          d="M10.8778 56.1852C10.6775 56.1852 10.4677 56.1852 10.2675 56.1852C9.33295 56.1976 8.35553 56.3884 7.40195 56.293C7.30182 56.3552 7.32089 56.9896 7.33996 57.143C8.77987 57.8272 12.0936 56.8984 13.3809 57.3545C13.5525 57.4167 13.2379 57.6323 13.4429 57.7774C13.872 57.5701 13.6765 56.7242 13.6241 56.293C12.7086 56.3925 11.7741 56.2018 10.8778 56.1852Z"
          fill="#7F8AA5"
        />
        <Path
          d="M92.9857 84.4683L91.3551 81.2299C91.0881 81.5119 90.6351 81.2382 90.4396 81.2299C90.349 81.2299 89.4622 81.4455 89.343 81.4414C89.4622 81.4414 90.3538 81.2258 90.4396 81.2299V81.0184V57.935C91.3026 57.7609 91.7508 58.1672 91.9034 57.2467H85.6813C85.8434 58.1423 86.1151 57.6282 86.9018 57.7775L84.0077 60.1202V21.6119C84.0077 21.2512 83.674 20.9609 83.2592 20.9609H16.6134C16.1986 20.9609 15.8648 21.2512 15.8648 21.6119V60.2612C14.9303 59.3531 13.8289 58.3746 12.5892 57.8811C12.8133 57.8314 13.4046 57.794 13.4427 57.7733C13.2425 57.6282 13.5524 57.4084 13.3807 57.3504C12.0934 56.8943 8.77969 57.8231 7.33978 57.1389C7.43991 58.0138 8.02159 57.8811 8.9275 57.9889C8.96564 57.9931 9.00855 57.9889 9.05146 57.9889V81.2299C8.90842 81.234 8.9275 81.3999 8.68433 81.2299V81.4414C8.64142 81.4414 8.60328 81.4414 8.56037 81.4414C8.51746 81.4414 8.04066 81.2382 7.76889 81.3336C7.39223 81.4704 6.40527 84.1573 6 84.6217C6.43865 84.6134 6.93928 84.5181 7.34455 84.5139C8.90842 84.5015 10.5295 84.6217 12.1029 84.6217C13.0374 84.6217 13.9719 84.6259 14.9112 84.6217C14.6633 84.2278 13.519 81.487 13.3235 81.3833C13.2138 81.3253 12.4176 81.2797 12.1029 81.2258C12.0648 81.2175 12.0171 81.2341 11.979 81.2258C12.184 81.4082 11.9551 81.458 11.6833 81.4621C11.9503 81.458 12.1792 81.4041 11.9742 81.2258C11.8216 81.1884 11.464 81.2921 11.3639 81.1719C11.464 81.2921 11.8216 81.1843 11.9742 81.2216C12.0123 81.2299 12.0552 81.2133 12.0982 81.2216V80.2679C12.0982 77.2286 12.2174 74.1726 12.2221 71.1415C12.2221 70.3661 12.2221 69.5825 12.2221 68.8071C12.2221 68.6246 12.0982 68.5251 12.0982 68.2763C12.0982 67.1485 12.2174 65.9958 12.2221 64.8804C12.2269 63.1637 12.1411 61.5176 12.2221 59.7885C13.066 61.2605 14.463 61.3227 15.8648 61.3683V69.1139C14.7443 68.5749 13.9815 67.4263 13.3235 66.4726C12.9802 65.9792 12.7275 65.4733 12.3461 64.9882C12.3318 64.9674 12.3652 64.8638 12.2221 64.8804C12.2221 65.9958 12.1029 67.1485 12.0982 68.2763C12.0982 68.5251 12.2221 68.6246 12.2221 68.8071C12.5797 69.0268 12.7943 69.3751 13.0756 69.6571C13.8527 70.4325 14.7586 71.1332 15.8648 71.3779C14.7634 71.1332 13.8575 70.4325 13.0756 69.6571C12.7943 69.3751 12.5797 69.0268 12.2221 68.8071C12.2221 69.5825 12.2221 70.3661 12.2221 71.1415C12.4701 71.0835 12.4557 71.241 12.4653 71.2493C13.5285 71.6516 14.7253 71.7594 15.8648 71.6474V83.838C15.8648 83.9624 15.9077 84.0744 15.9745 84.1739C15.9316 84.2071 15.8934 84.2319 15.8648 84.2485L16.1366 84.4849H16.5418C16.5657 84.4849 16.5895 84.4932 16.6181 84.4932H19.1117C19.0927 84.5429 20.0558 84.5471 20.0701 84.5305C20.0606 84.5512 20.0463 84.572 20.0367 84.5885C20.0367 84.5885 26.2159 84.6217 26.1396 84.489H73.2561C73.2513 84.5346 77.7379 84.489 77.7379 84.489H83.2592C83.283 84.489 83.3116 84.4849 83.3354 84.4807H83.9839C84.1841 84.4061 84.1412 84.2361 83.9744 84.0288C83.9982 83.9666 84.0125 83.9044 84.0125 83.8339V71.6723C84.8326 71.6972 85.667 71.6018 86.4203 71.353C87.9508 70.8388 87.1164 69.9764 87.1545 68.8071C87.1975 67.53 87.288 66.2694 87.2785 64.9882C86.282 65.9004 85.338 67.9985 84.0173 68.9066V61.3932C85.0996 61.3061 86.1199 61.1071 87.0353 60.2114C87.0353 59.8258 87.2833 59.1873 87.1593 58.727C87.1975 58.6772 87.2118 58.3165 87.4025 58.3041V72.9494C87.4025 72.9992 87.4025 73.0448 87.4025 73.0945V72.9494C87.4025 74.8609 87.3548 76.7849 87.4025 78.7006V78.6632C87.4215 79.4842 87.4597 80.3011 87.5264 81.1179C87.4597 80.3135 87.4263 79.505 87.4025 78.7006V81.1179V81.2258C87.4025 81.2258 87.331 81.3087 87.0353 81.3336C86.7302 81.3584 86.1676 81.2631 85.9387 81.3875C85.7671 81.4787 84.618 84.2361 84.351 84.6259C84.7944 84.6383 85.2474 84.6259 85.6956 84.6259C87.1689 84.6259 88.666 84.7876 90.1488 84.6259L90.1106 84.4683H93H92.9857ZM12.2936 68.2556C12.4128 68.1727 12.3413 67.9529 12.3461 67.8078C12.3747 66.8707 12.3222 65.9294 12.3461 64.9965C12.3222 65.9294 12.3747 66.8748 12.3461 67.8078C12.3461 67.9529 12.4128 68.1768 12.2936 68.2597V68.2556ZM10.9396 57.9972C10.7536 57.9972 10.5677 57.9889 10.3912 57.9848C10.5724 57.9848 10.7536 57.9931 10.9396 57.9972ZM10.1385 81.4289C10.52 81.4414 10.9014 81.4704 11.2447 81.545C10.8966 81.4662 10.52 81.4372 10.1385 81.4248V81.4289Z"
          fill="#7F8AA5"
        />
        <Path
          d="M6.88682 53.5729C6.90589 53.6724 6.92973 53.7719 6.95834 53.8673C6.96787 53.8963 6.97264 53.9254 6.98218 53.9544C7.02509 54.0746 7.07277 54.1907 7.12998 54.3068C7.13952 54.3276 7.15382 54.3483 7.16336 54.369C7.21104 54.4603 7.26825 54.5515 7.32547 54.6386C7.335 54.6551 7.34454 54.6717 7.35407 54.6883C7.35407 54.6883 7.35884 54.6883 7.36361 54.6925C7.99297 55.5798 9.1182 56.1769 10.4055 56.1769C12.3794 56.1769 13.9767 54.7878 13.9767 53.0712C13.9767 52.0968 13.4618 51.2302 12.656 50.6621C12.5797 50.6082 12.4986 50.5543 12.4128 50.5045C12.3842 50.4879 12.3556 50.4755 12.327 50.4589C12.265 50.4257 12.203 50.3884 12.1363 50.3594C12.0981 50.3428 12.06 50.3262 12.0171 50.3055C11.9599 50.2806 11.9027 50.2557 11.8407 50.2309C11.7978 50.2143 11.7549 50.2018 11.7119 50.1852C11.6547 50.1645 11.5927 50.1438 11.5308 50.1272C11.4878 50.1148 11.4449 50.1023 11.3973 50.0899C11.3353 50.0733 11.2685 50.0609 11.2018 50.0443C11.1589 50.036 11.116 50.0277 11.073 50.0194C11.0015 50.0069 10.9252 49.9987 10.8489 49.9904C10.8108 49.9862 10.7727 49.9821 10.7345 49.9779C10.6201 49.9696 10.5057 49.9613 10.3912 49.9613C8.41732 49.9613 6.82007 51.3504 6.82007 53.067C6.82007 53.1997 6.83437 53.3283 6.85344 53.4568C6.85821 53.4941 6.86775 53.5273 6.87251 53.5646L6.88682 53.5729Z"
          fill="#7F8AA5"
        />
        <Path
          d="M85.314 53.5729C85.3331 53.6724 85.3569 53.7719 85.3856 53.8714C85.3951 53.9005 85.3999 53.9295 85.4094 53.9544C85.4523 54.0746 85.5 54.1949 85.5572 54.311C85.5667 54.3317 85.581 54.3483 85.5906 54.369C85.6383 54.4644 85.6955 54.5556 85.7575 54.6427C85.767 54.6593 85.7765 54.6758 85.7861 54.6924C85.7861 54.6924 85.7908 54.6924 85.7956 54.6966C86.425 55.5839 87.5502 56.181 88.8375 56.181C90.8067 56.181 92.4087 54.792 92.4087 53.0753C92.4087 52.105 91.8938 51.2343 91.088 50.6662C91.0069 50.6123 90.9259 50.5584 90.8448 50.5086C90.821 50.4921 90.7924 50.4796 90.7685 50.4672C90.7018 50.4299 90.6398 50.3967 90.5683 50.3635C90.5301 50.3469 90.492 50.3303 90.4538 50.3138C90.3966 50.2889 90.3346 50.264 90.2727 50.2391C90.2297 50.2225 90.1916 50.2101 90.1487 50.1935C90.0867 50.1728 90.0295 50.152 89.9675 50.1355C89.9246 50.123 89.8817 50.1106 89.8388 50.0981C89.772 50.0816 89.7101 50.0691 89.6433 50.0525C89.6004 50.0442 89.5575 50.0359 89.5146 50.0277C89.443 50.0152 89.3668 50.0069 89.2905 49.9986C89.2523 49.9986 89.219 49.9903 89.1808 49.9862C89.0664 49.9779 88.952 49.9696 88.8375 49.9696C86.8636 49.9696 85.2664 51.3587 85.2664 53.0753C85.2664 53.208 85.2807 53.3365 85.2997 53.4651C85.3045 53.5024 85.314 53.5356 85.3188 53.5729H85.314Z"
          fill="#7F8AA5"
        />
        <Path
          d="M81.1838 15H18.6339C18.2448 15 17.9294 15.3154 17.9294 15.7045V82.8649C17.9294 83.254 18.2448 83.5694 18.6339 83.5694H81.1838C81.5728 83.5694 81.8882 83.254 81.8882 82.8649V15.7045C81.8882 15.3154 81.5728 15 81.1838 15Z"
          fill="#515151"
        />
        <Path
          d="M77.5254 19.1705L77.6272 79.1234C78.2899 79.6643 78.9032 80.5629 79.5664 81.0625C79.754 81.2035 79.7127 81.2963 79.9743 81.1135L80.0762 81.4196H20.1742C20.1817 81.3542 20.1592 81.2679 20.1742 81.2153C20.2343 81.0019 21.9927 79.6096 22.2152 79.2252L22.3171 50.6009C22.7353 51.0518 23.2146 51.4753 23.6434 51.9272C23.0505 52.3942 23.3679 52.7421 23.3373 53.1517C23.0821 56.5604 23.2135 60.0462 23.3373 63.4586C23.3443 63.6564 23.1127 64.3898 23.2355 64.6321L23.6434 64.4788L23.2355 65.0401V79.0205C25.1033 79.1277 26.9792 79.0526 28.8481 79.0714C29.2346 79.0751 29.5836 79.0757 29.9707 79.0714C31.0204 79.0596 32.0868 79.117 33.1343 79.0714C33.4051 79.0596 33.6024 79.2317 33.8999 79.1732L34.1551 78.969L76.5561 79.0708L76.4027 37.7416L76.607 37.4864C76.6778 37.2114 76.4987 36.8875 76.5051 36.8232C77.0439 31.3092 76.3566 25.2474 76.5561 19.6793H23.3888L23.2355 47.2319C22.9079 47.5649 22.523 47.9165 22.2152 48.2522L22.3686 19.1683H77.5254V19.1705Z"
          fill="#A6A9B1"
        />
        <Path
          d="M79.8724 17.0271L77.5253 19.1699H22.3685L22.2152 48.2537C22.056 48.4274 21.1821 49.3061 21.195 49.4273C21.5954 49.7945 21.9493 50.2041 22.3176 50.6009L22.2157 79.2252C21.9938 79.6096 20.2353 81.0019 20.1747 81.2153L19.9705 16.9761L79.8724 17.0271Z"
          fill="#C9C9CB"
        />
        <Path
          d="M79.9744 81.1129C79.7122 81.2952 79.7535 81.2029 79.5664 81.0619C78.9032 80.5623 78.2899 79.6643 77.6273 79.1228L77.5254 19.1699L79.8725 17.027L79.9744 81.1129Z"
          fill="#C9C9CB"
        />
        <Path
          d="M20.174 81.4196H80.0759C80.3285 81.7005 82.5314 83.2692 81.8617 83.5624H18.1839L17.9287 83.3072C18.2874 83.074 19.6963 81.374 19.9188 81.3172C19.9322 81.314 19.9794 81.441 20.174 81.419V81.4196Z"
          fill="#777777"
        />
        <Path
          d="M28.8487 79.0724C26.9798 79.0537 25.1039 79.1287 23.2361 79.0215V65.0412L23.6441 64.4799L29.0015 59.0715C30.5691 60.4043 35.1931 66.2909 36.9612 66.5209C37.6791 66.6141 37.5064 66.3311 37.8287 66.1129C40.5575 64.2627 44.832 59.3358 47.4214 56.8268C48.3076 58.7166 51.238 56.1588 52.2175 55.2962L28.8487 79.0735V79.0724Z"
          fill="white"
        />
        <Path
          d="M76.4027 37.7426L34.155 78.97L33.8999 79.1743C33.6023 79.2322 33.4056 79.0606 33.1343 79.0724L76.5045 36.8248C76.4981 36.8891 76.6777 37.2129 76.6064 37.488L76.4021 37.7432L76.4027 37.7426Z"
          fill="#C9C9CB"
        />
        <Path
          d="M23.3376 63.4591C23.2137 60.0467 23.0824 56.5609 23.3376 53.1522L28.2361 58.3054L23.3376 63.4585V63.4591Z"
          fill="white"
        />
        <Path
          d="M29.9708 79.0724C29.5842 79.0767 29.2347 79.0762 28.8481 79.0724L52.217 55.2951C53.5535 54.1183 55.0337 52.4263 56.299 51.1112C54.1743 53.9923 51.6122 56.6064 49.1557 59.2243C42.8558 65.9365 36.1517 72.2584 29.9708 79.0724Z"
          fill="#C9C9CB"
        />
        <Path
          d="M29.1549 57.5403C28.4853 58.1269 27.9904 58.2872 28.8997 58.9691L29.7671 58.1526C30.3568 58.7445 31.0131 59.2967 31.6039 59.8875L34.9712 63.2548C35.4805 63.7641 35.9925 64.2761 36.5018 64.7854C36.9414 65.2245 37.3146 65.7462 37.8282 66.1118C37.506 66.3305 37.6786 66.6136 36.9607 66.5198C35.1926 66.2892 30.5686 60.4032 29.001 59.0704L23.6436 64.4788L23.2356 64.6321C23.1128 64.3898 23.345 63.6564 23.3375 63.4585L28.236 58.3054L23.3375 53.1522C23.368 52.7426 23.0506 52.3947 23.6436 51.9277C25.446 53.8261 27.3133 55.6784 29.1543 57.5403H29.1549Z"
          fill="#C9C9CB"
        />
        <Path
          d="M67.6267 24.1703C67.0836 26.9806 66.5984 29.8134 65.8918 32.5895C65.1267 35.5949 63.9468 38.5522 63.2385 41.5185C60.588 44.0704 57.9283 46.6191 55.2788 49.1721L58.9523 32.2324C61.7755 29.4993 64.5365 26.6906 67.3715 23.9666L67.6267 24.1708V24.1703Z"
          fill="url(#paint3_linear_8631_20754)"
        />
        <Path
          d="M55.2789 49.1721C55.1084 49.3367 54.9428 49.5147 54.7685 49.6825C55.2703 49.2766 53.4384 48.6537 53.3398 48.6623C51.5808 46.7242 49.5537 45.0209 47.6253 43.2539C47.6082 43.2384 47.6425 43.1676 47.6253 43.152C51.3964 39.5102 55.1862 35.8796 58.9524 32.2329L55.2789 49.1726V49.1721Z"
          fill="#D592F3"
        />
        <Path
          d="M70.6879 34.4771C68.2362 36.8499 65.6977 39.151 63.2385 41.5184C63.9467 38.5521 65.1267 35.5949 65.8918 32.5894C66.5984 29.8139 67.083 26.9806 67.6266 24.1702L74.3619 30.7521C73.2232 32.0662 71.9354 33.2697 70.6884 34.4771H70.6879Z"
          fill="url(#paint4_linear_8631_20754)"
        />
        <Path
          d="M56.2995 51.1113C55.0342 52.4263 53.554 54.1183 52.2175 55.2951C51.2375 56.1577 48.3071 58.7155 47.4214 56.8257C49.8731 54.4491 52.3102 52.0521 54.7689 49.6825C54.9431 49.5147 55.1088 49.3367 55.2793 49.1721C57.9287 46.6191 60.5884 44.0704 63.239 41.5185C65.6982 39.151 68.2372 36.85 70.6883 34.4771C68.9036 36.9192 66.8626 39.2679 64.8715 41.5694C62.0933 44.7808 59.2412 48.0527 56.2995 51.1107V51.1113Z"
          fill="#C9C9CB"
        />
        <Path
          d="M31.6037 59.8875C31.0129 59.2966 30.3567 58.745 29.7669 58.1526C29.5643 57.9494 29.3557 57.7435 29.1547 57.5403C27.3137 55.6784 25.4469 53.8261 23.6439 51.9277C23.2145 51.4752 22.7358 51.0517 22.3176 50.6014C21.9493 50.2046 21.5954 49.795 21.195 49.4278C21.1826 49.3066 22.056 48.4279 22.2152 48.2542C22.5235 47.9186 22.9078 47.5669 23.2354 47.234C27.3769 43.0217 31.7715 39.0245 35.8894 34.7843L31.6031 59.888L31.6037 59.8875Z"
          fill="url(#paint5_linear_8631_20754)"
        />
        <Path
          d="M36.2982 34.5795C39.5953 37.9179 43.1155 41.0312 46.5032 44.2741C47.7824 45.4986 49.017 46.8051 50.2791 48.05L34.9718 63.2554L31.6045 59.888L35.8907 34.7843C35.9513 34.5098 36.1733 34.623 36.2987 34.5801L36.2982 34.5795Z"
          fill="url(#paint6_linear_8631_20754)"
        />
        <Path
          d="M47.6252 43.1515C47.6424 43.167 47.6081 43.2378 47.6252 43.2534L46.5026 44.2736C43.1154 41.0306 39.5947 37.9174 36.2976 34.579C36.8026 34.4069 37.3736 34.4535 37.8792 34.2729C41.0546 37.311 44.3876 40.1836 47.6247 43.151L47.6252 43.1515Z"
          fill="#C9C9CB"
        />
        <Path
          d="M54.7685 49.6825C52.3099 52.0526 49.8727 54.4491 47.421 56.8257C44.8321 59.3353 40.5571 64.2616 37.8283 66.1118C37.3147 65.7456 36.941 65.2245 36.502 64.7854L52.9318 48.866C53.0519 48.8392 53.2395 48.6703 53.3398 48.6617C53.44 48.6531 55.2703 49.2761 54.7685 49.6819V49.6825Z"
          fill="#8768D4"
        />
        <Path
          d="M29.7671 58.1526L28.8996 58.9691C27.9904 58.2872 28.4852 58.1274 29.1548 57.5404C29.3559 57.7436 29.5644 57.9494 29.7671 58.1526Z"
          fill="#C9C9CB"
        />
        <Path
          d="M52.9317 48.866L36.5018 64.7854C35.992 64.2761 35.4805 63.7641 34.9712 63.2548L50.2784 48.0495L52.9317 48.866Z"
          fill="#5F419F"
        />
        <Path
          d="M53.3403 48.6617C53.2395 48.6703 53.0524 48.8387 52.9323 48.866L50.279 48.0495C49.0176 46.8046 47.7823 45.4981 46.5032 44.2736L47.6258 43.2534C49.5542 45.0204 51.5813 46.7237 53.3403 48.6617Z"
          fill="#A574C8"
        />
        <Path
          d="M76.5045 36.8243L33.1342 79.0719C32.0872 79.1175 31.0203 79.0601 29.9706 79.0719C36.1515 72.2578 42.8556 65.936 49.1555 59.2238C51.612 56.6064 54.1741 53.9918 56.2988 51.1107C59.2404 48.0522 62.0926 44.7808 64.8707 41.5694C66.8619 39.2679 68.9029 36.9191 70.6876 34.4771C71.9346 33.2698 73.2224 32.0662 74.3611 30.7522L67.6259 24.1703L67.3707 23.966C64.5362 26.69 61.7747 29.4987 58.9515 32.2319C55.1853 35.8785 51.3954 39.5091 47.6244 43.151C44.3873 40.1836 41.0543 37.311 37.8789 34.2729C37.3733 34.4535 36.8023 34.4069 36.2973 34.579C36.1719 34.6219 35.9499 34.5088 35.8893 34.7833C31.7714 39.0234 27.3769 43.0212 23.2354 47.233L23.3887 19.6803H76.5554C76.3554 25.2484 77.0433 31.3103 76.5045 36.8243Z"
          fill="white"
        />
        <Path
          d="M32.1139 31.008C31.8673 31.2792 32.0067 31.7044 31.7059 32.0797C30.9023 33.0806 29.4275 32.6383 28.7466 31.7226C29.0216 30.2043 31.425 29.724 32.1139 31.0085V31.008Z"
          fill="#F5F0FF"
        />
        <Path
          d="M32.1139 31.008C33.9426 34.415 28.0593 35.5108 28.7466 31.7221C29.4275 32.6377 30.9023 33.0806 31.706 32.0791C32.0073 31.7038 31.8673 31.2792 32.1139 31.0074V31.008Z"
          fill="#C6A9FF"
        />
        <Path
          d="M40.1755 25.1911C39.9793 26.9672 38.0476 27.2401 37.1143 25.8033C37.3614 24.5118 39.381 23.9617 40.1755 25.1911Z"
          fill="#F5F0FF"
        />
        <Path
          d="M37.1142 25.8033C38.0476 27.2401 39.9798 26.9672 40.1755 25.1911C40.2462 25.301 40.4725 25.7722 40.4816 25.8542C40.8167 28.9535 36.5695 28.6496 37.1142 25.8033Z"
          fill="#C6A9FF"
        />
        <Path
          d="M58.5441 25.3953C59.4255 26.3936 60.747 26.2327 61.0955 24.8849C62.4599 27.3816 58.0337 28.2775 58.5441 25.3953Z"
          fill="#C6A9FF"
        />
        <Path
          d="M61.0953 24.8849C60.7474 26.2327 59.4253 26.3936 58.5439 25.3953C58.7396 24.2909 60.4976 23.7913 61.0953 24.8849Z"
          fill="#F5F0FF"
        />
        <Path
          d="M43.9514 33.049C44.0752 33.9346 43.1981 34.4461 42.3698 34.2735C42.0696 34.2107 41.8444 33.5615 41.6042 33.9673C41.6257 32.7 43.1574 32.0706 43.9514 33.049Z"
          fill="#F5F0FF"
        />
        <Path
          d="M41.6041 33.9673C41.8443 33.5615 42.0695 34.2107 42.3697 34.2734C43.198 34.4461 44.0756 33.9346 43.9513 33.049C45.573 35.0465 41.5586 36.6779 41.6041 33.9673Z"
          fill="#C6A9FF"
        />
        <Path
          d="M49.309 24.6807C55.7628 23.7945 55.5698 33.324 49.309 32.5386C44.9359 31.9896 45.0394 25.2672 49.309 24.6807Z"
          fill="#B586E2"
        />
        <Path
          d="M49.4106 25.1911C55.0832 24.3944 54.8163 32.7299 49.4106 32.0282C45.4867 31.5189 45.7007 25.7122 49.4106 25.1911Z"
          fill="#082026"
        />
        <Path
          d="M47.5229 30.4976C48.9211 29.0635 50.7724 28.5279 52.5742 27.8443C52.7705 27.7698 53.0659 27.7108 53.0337 27.4363C54.3794 30.8289 49.7371 33.3175 47.5229 30.4976Z"
          fill="#4665B6"
        />
        <Path
          d="M53.0336 27.4363C53.0663 27.7108 52.7704 27.7703 52.5742 27.8443C50.7723 28.5278 48.9206 29.0634 47.5229 30.4975C47.2581 30.1598 47.0098 29.7995 46.9106 29.3749C48.3968 27.9113 50.3252 27.0937 52.2171 26.3137C52.7281 26.7613 52.779 26.7946 53.0336 27.4363Z"
          fill="#819FEE"
        />
        <Path
          d="M52.2173 26.3137C50.3254 27.0937 48.397 27.9113 46.9109 29.3749C46.8181 28.9777 46.7532 28.5573 46.809 28.1504L51.5032 25.8033C51.9252 25.9722 51.9241 26.0564 52.2173 26.3137Z"
          fill="#4665B6"
        />
        <Path
          d="M51.5026 25.8033L46.8083 28.1504C47.0941 26.0553 49.6337 25.0554 51.5026 25.8033Z"
          fill="#819FEE"
        />
        <Path
          d="M34.155 78.97L76.4027 37.7426L76.5555 79.0724L34.155 78.97Z"
          fill="url(#paint7_linear_8631_20754)"
        />
        <Path
          d="M47.8293 73.1531C47.6669 74.5471 46.3244 74.7449 45.4822 73.7654C45.6253 72.6331 47.2498 72.194 47.8293 73.1531Z"
          fill="#F5F0FF"
        />
        <Path
          d="M45.4821 73.7659C46.3244 74.7454 47.6663 74.5476 47.8293 73.1537C49.2414 75.4912 45.1262 76.5838 45.4821 73.7659Z"
          fill="#7E9FF8"
        />
        <Path
          d="M70.8918 71.5207C70.6329 72.9414 69.5579 72.9811 68.5447 72.1329C68.6916 71.1454 70.2672 70.5589 70.8918 71.5207Z"
          fill="#F5F0FF"
        />
        <Path
          d="M68.545 72.1329C69.5583 72.9811 70.6332 72.9414 70.8922 71.5207C72.3563 73.7767 68.1606 74.7149 68.545 72.1329Z"
          fill="#7E9FF8"
        />
        <Path
          d="M54.156 71.3164C53.5475 72.2804 52.8527 72.3988 52.0132 71.6225C52.2469 70.412 53.784 70.279 54.156 71.3164Z"
          fill="#F5F0FF"
        />
        <Path
          d="M54.1561 71.3164C54.9056 73.4062 51.6122 73.7005 52.0133 71.6225C52.8528 72.3983 53.5476 72.2803 54.1561 71.3164Z"
          fill="#7E9FF8"
        />
        <Path
          d="M68.5446 51.9278C69.6056 53.6305 72.2674 53.1898 72.1162 51.0094C72.2872 51.2351 72.4909 51.6082 72.5242 51.8768C73.0062 55.7481 67.7731 55.2329 68.5446 51.9278Z"
          fill="#7E9FF8"
        />
        <Path
          d="M72.1163 51.0089C72.2675 53.1892 69.6057 53.6299 68.5447 51.9272C68.8996 50.4057 71.0928 49.6552 72.1163 51.0089Z"
          fill="#F5F0FF"
        />
        <Path
          d="M70.2289 50.907C72.2993 50.6829 70.3565 52.3379 69.1572 51.5701C69.0939 51.4163 70.0959 50.9214 70.2289 50.907Z"
          fill="#F5F0FF"
        />
        <Path
          d="M61.4524 59.8875C68.6835 58.8871 69.797 68.6991 63.5952 69.8882C56.1593 71.3143 55.0232 60.7769 61.4524 59.8875Z"
          fill="#DEDEDE"
        />
        <Path
          d="M61.8605 60.4997C68.1186 59.8821 68.6274 68.557 63.2892 69.276C56.6548 70.1697 56.0726 61.0712 61.8605 60.4997Z"
          fill="#082026"
        />
        <Path
          d="M66.6063 64.6836C66.8234 69.3183 60.0538 70.45 58.5447 66.4184C61.08 65.2706 63.8104 64.6643 66.6063 64.6836Z"
          fill="#4665B6"
        />
        <Path
          d="M65.9935 62.8468C66.3414 63.4425 66.5719 63.9652 66.6057 64.6836C63.8093 64.6643 61.0794 65.2706 58.5441 66.4184C58.3441 65.8839 58.2235 65.2578 58.238 64.6836C60.7358 63.7625 63.2893 62.8683 65.9935 62.8468Z"
          fill="#819FEE"
        />
        <Path
          d="M65.9935 62.8468C63.2893 62.8683 60.7358 63.7625 58.238 64.6836C58.2536 64.0793 58.4042 63.7759 58.646 63.2548L65.0751 61.826C65.4863 62.1327 65.7335 62.4013 65.9935 62.8463V62.8468Z"
          fill="#4665B6"
        />
        <Path
          d="M65.0751 61.826L58.646 63.2548C59.782 60.8069 62.9574 60.2472 65.0751 61.826Z"
          fill="#819FEE"
        />
        <Path
          d="M89.3008 54.1628C89.1565 55.1573 88.7368 54.7209 87.9262 54.9075V79.8182C87.6098 80.0069 87.2394 79.9276 86.8952 79.9329L87.0099 55.137C86.7698 54.7301 86.1168 55.0903 85.979 55.0796C85.675 55.0566 85.1083 55.086 85.0628 55.0796C84.7186 55.0303 84.8617 54.7922 84.6044 54.736C83.8677 54.5751 83.6131 55.1289 83.4592 54.1634H89.3002L89.3008 54.1628Z"
          fill="#1A264F"
        />
        <Path
          d="M89.3009 54.1628H83.4599C83.4347 54.0052 83.4315 53.193 83.5172 53.1319C84.2228 53.2198 88.9052 52.8482 89.1293 53.0171C89.3733 53.201 89.3406 53.8921 89.3009 54.1623V54.1628Z"
          fill="#3D3D54"
        />
        <Path
          d="M79.3365 58.7439C79.4785 58.7439 79.6753 58.7697 79.7948 58.7439V58.8587C78.9108 59.0318 78.2605 59.7615 76.9314 59.6602C76.8719 59.6559 75.9455 59.3701 75.7863 59.3165C75.619 59.2602 75.4534 58.9841 75.099 58.8581C74.6406 58.3381 74.1651 57.7532 73.9538 57.083C73.86 56.7866 74.0991 56.5014 74.0686 56.3384L77.4472 58.8581C77.9458 58.8528 79.1445 59.3959 79.337 58.7434L79.3365 58.7439Z"
          fill="#5F3266"
        />
        <Path
          d="M73.9535 55.6516C74.4649 55.798 75.4257 56.0419 76.0149 55.8805L78.1336 58.4003C78.6215 58.7005 78.756 58.7418 79.3361 58.7439C79.1436 59.3964 77.9449 58.8533 77.4463 58.8587L74.0677 56.3389C73.9738 55.8473 73.598 55.8746 73.3804 55.5374V55.4227C73.6736 55.6018 73.6495 55.5648 73.9529 55.6516H73.9535Z"
          fill="#9962AE"
        />
        <Path
          d="M84.8339 55.7658C84.9546 56.2612 84.7192 56.9528 84.7192 57.3693C83.2942 58.9814 81.5851 58.5075 79.7944 58.8581V58.7434C80.2523 58.6448 80.7873 58.0266 81.2832 57.8272C82.7361 57.2433 83.8373 57.2214 84.8339 55.7658Z"
          fill="#9962AE"
        />
        <Path
          d="M85.0636 55.0791V55.308C84.8824 55.3214 84.8711 55.7122 84.8346 55.7664C83.8385 57.2219 82.7368 57.2439 81.2839 57.8277L84.6052 54.7354C84.862 54.7917 84.7188 55.0297 85.0636 55.0791Z"
          fill="#D592F3"
        />
        <Path
          d="M87.9264 80.0466C87.8433 80.0423 87.008 80.2787 86.8954 80.2755C86.4526 80.2626 85.4694 80.0273 85.063 80.0466V79.9318H86.0939C86.3599 79.9318 86.6295 79.9356 86.8954 79.9318C87.2396 79.9265 87.6095 80.0058 87.9264 79.8171V80.046V80.0466Z"
          fill="#A18880"
        />
        <Path
          d="M76.2442 65.3864V80.2755C76.077 80.261 76.1574 80.5081 76.0727 80.5044C75.7092 80.4883 75.3484 80.5242 74.9844 80.5044L74.8696 61.9504C75.1103 62.8366 75.8137 64.5613 76.2442 65.3864Z"
          fill="#283A69"
        />
        <Path
          d="M74.4119 59.0876C74.7508 59.7985 74.6312 61.0728 74.8703 61.951L74.9851 80.5049C74.947 80.5028 74.9084 80.5081 74.8703 80.5049C74.6816 80.4883 74.0383 80.5666 73.9541 80.4476L74.183 58.8013C74.2747 58.7429 74.3943 59.0506 74.4119 59.0876Z"
          fill="#7482B0"
        />
        <Path
          d="M86.8957 80.276L87.6404 83.712C86.2465 83.8852 84.8445 83.7115 83.4597 83.712L84.7196 80.1613C84.9984 80.1356 85.045 80.0476 85.0632 80.0466C85.4702 80.0273 86.4529 80.2626 86.8957 80.2755V80.276Z"
          fill="#585366"
        />
        <Path
          d="M74.8694 80.7339C75.1048 80.765 75.3305 80.706 75.5567 80.6765L76.0151 83.6541C74.8823 84.0433 73.7055 83.6863 72.5791 83.7115L73.839 80.6191C74.1848 80.609 74.529 80.6883 74.8699 80.7339H74.8694Z"
          fill="#3D3D54"
        />
        <Path
          d="M84.7197 80.1613L83.4598 83.712C83.0427 83.712 82.6165 83.7265 82.2 83.712C82.4492 83.2911 83.5263 80.3173 83.6887 80.2187C83.9069 80.0862 84.4313 80.1881 84.7197 80.1613Z"
          fill="#88818B"
        />
        <Path
          d="M73.8392 80.6197L72.5793 83.712C72.3075 83.7179 72.0416 83.7077 71.7778 83.712C71.8116 83.067 72.337 81.7605 72.6941 81.1922C72.76 81.0872 72.7691 80.7044 72.9803 80.6197C73.0961 80.573 73.6339 80.6256 73.8392 80.6197Z"
          fill="#88818B"
        />
        <Path
          d="M86.8957 79.9323C86.6298 79.9361 86.3601 79.9323 86.0942 79.9323L85.9795 55.079C86.1167 55.0892 86.7703 54.7295 87.0104 55.1364L86.8957 79.9323Z"
          fill="#404D7D"
        />
        <Path
          d="M85.9797 55.079L86.0944 79.9324H85.1782C84.968 77.0036 85.0645 74.0485 85.0634 71.1132C85.0634 70.8087 85.0634 70.5015 85.0634 70.197C85.0634 69.0154 85.0634 67.8284 85.0634 66.6463V55.0785C85.109 55.0849 85.6757 55.0555 85.9797 55.0785V55.079Z"
          fill="#8894BE"
        />
        <Path
          d="M75.0989 58.8581C75.4533 58.9841 75.6189 59.2602 75.7862 59.3165C76.2923 61.728 77.4718 67.4966 80.8257 67.2194C82.6662 67.0672 83.7647 63.7657 84.949 62.5236C84.9581 63.9094 84.8745 65.269 84.8343 66.6468C83.8231 68.0279 82.5649 69.2599 80.8257 69.6244C78.7863 69.2325 77.149 67.1218 76.2446 65.387C75.8146 64.5619 75.1112 62.8372 74.87 61.951C74.6314 61.0728 74.7504 59.7985 74.4116 59.0876C74.3269 58.3268 74.6974 58.7161 75.0989 58.8587V58.8581Z"
          fill="#D592F3"
        />
        <Path
          d="M76.9316 59.6602C77.4902 62.4383 78.3475 65.5312 80.8254 67.2194C77.4714 67.4971 76.292 61.7285 75.7859 59.3165C75.9451 59.3701 76.8715 59.6554 76.931 59.6602H76.9316Z"
          fill="#90579B"
        />
        <Path
          d="M85.1776 79.9324H85.0629V71.1133C85.0634 74.0485 84.9675 77.0036 85.1776 79.9324Z"
          fill="white"
        />
        <Path
          d="M84.1464 69.3955C83.1139 69.7933 81.9092 69.833 80.8252 69.6244C82.5644 69.2594 83.8226 68.0279 84.8337 66.6469C84.7973 67.9089 85.5838 68.8423 84.1464 69.3955Z"
          fill="#90579B"
        />
        <Path
          d="M23.6742 55.5369C24.3213 55.7599 24.0993 55.8655 25.163 55.8805C25.1539 56.5485 23.6297 57.9178 23.0443 58.2856C22.1366 58.8554 21.5753 58.8978 20.5819 59.2018C20.101 59.1133 19.6721 58.8013 19.3794 58.7434C17.6654 58.4046 15.6014 59.0935 14.512 56.9109C14.5275 56.533 14.512 56.1443 14.512 55.7658C14.9832 56.221 15.4732 56.9388 16.0581 57.2546C16.8693 57.6921 17.6091 57.5832 18.2916 57.8272C18.7232 57.9816 19.3343 58.6673 19.723 58.7434C21.3877 59.0694 22.6556 57.1163 23.6742 56.0521C23.6699 56.0092 23.1027 55.6387 22.9869 55.5369V55.4221C23.1435 55.531 23.553 55.4951 23.6742 55.5369Z"
          fill="#9962AE"
        />
        <Path
          d="M14.8551 54.8496C16.1815 55.4554 17.3395 56.7442 18.2911 57.8272C17.6086 57.5833 16.8688 57.6921 16.0576 57.2546C15.4727 56.9389 14.9827 56.221 14.5115 55.7658V54.9643C14.5292 54.9617 14.7088 54.8877 14.8551 54.8496Z"
          fill="#D592F3"
        />
        <Path
          d="M15.3134 67.5626C16.2768 68.668 17.4515 69.6346 18.9783 69.5097C17.6284 69.8711 16.0704 69.8609 14.7409 69.2808C14.7291 69.2754 14.7452 69.1039 14.5119 69.1661C14.5119 68.3287 14.5103 67.4848 14.5119 66.6463C14.8486 66.8817 15.0497 67.2596 15.3134 67.5626Z"
          fill="#90579B"
        />
        <Path
          d="M25.4491 83.712C25.3124 83.6418 24.6814 80.9312 24.7045 80.7344C24.7179 80.6202 24.8251 80.6068 24.8192 80.5055C24.9881 80.5371 24.928 80.9751 25.2776 80.5629L24.8192 61.1495C24.9447 60.6536 24.8798 59.9148 25.1629 59.4318C25.1629 66.3338 25.4009 73.2556 25.2776 80.1618C25.2481 80.7274 25.9215 80.402 26.1364 80.5055C26.5932 80.7248 27.4923 83.7233 27.74 83.8267"
          fill="#1A264F"
        />
        <Path
          d="M22.9869 80.6197C22.7741 81.0673 22.0621 83.4659 21.8418 83.6546C21.5131 83.9361 21.0161 83.7007 20.9255 83.712C21.0987 83.2424 21.8407 81.0169 22.0707 80.7912C22.3731 80.4953 22.6363 80.6567 22.9869 80.6197Z"
          fill="#88818B"
        />
        <Path
          d="M25.6213 55.9953C25.3012 56.5625 25.6856 57.2005 25.1629 58.0566C25.0771 58.1971 23.8537 59.2388 23.6741 59.3165C23.3626 59.4516 22.9857 59.5197 22.6432 59.5454C21.6036 59.6237 21.3822 59.3492 20.5818 59.2018C21.5752 58.8978 22.1365 58.8555 23.0442 58.2856C23.6296 57.9178 25.1538 56.5485 25.1629 55.8805C25.3082 55.8827 25.5934 55.8076 25.6213 55.9953Z"
          fill="#5F3266"
        />
        <Path
          d="M24.132 80.3902C23.8817 80.3414 23.4078 80.4578 23.2158 80.3902V65.3864C23.6603 64.496 24.0543 63.4704 24.361 62.523L24.132 80.3902Z"
          fill="#8894BE"
        />
        <Path
          d="M24.8194 80.5049C24.5947 80.4631 24.3605 80.4347 24.1321 80.3902L24.361 62.523C24.494 62.1118 24.7229 61.5291 24.8194 61.1484L25.2778 80.5618C24.9287 80.9746 24.9888 80.536 24.8194 80.5044V80.5049Z"
          fill="#404D7D"
        />
        <Path
          d="M23.6742 59.3165C23.3761 61.372 22.6931 63.7915 21.4981 65.5012C20.6832 66.6672 19.9262 67.5969 18.5205 67.2189C21.0317 65.6776 22.1275 62.3075 22.6438 59.5455C22.9858 59.5197 23.3633 59.4511 23.6747 59.3165H23.6742Z"
          fill="#90579B"
        />
        <Path
          d="M23.6741 59.3165C23.3761 61.372 22.693 63.7915 21.498 65.5012C20.6831 66.6672 19.9261 67.5969 18.5204 67.2189C17.133 66.8458 16.2736 65.3377 15.5429 64.1266C15.2217 63.5947 14.9826 63.0474 14.6266 62.523C14.6052 63.532 14.6556 64.5485 14.6266 65.558C14.6207 65.7671 14.7414 66.1236 14.3977 66.0732C14.3972 66.3434 14.5124 66.4501 14.5124 66.6458C14.8491 66.8811 15.0502 67.2591 15.3139 67.562C16.2773 68.6675 17.452 69.6341 18.9788 69.5092C20.6263 69.068 21.891 67.6483 22.6437 66.1879C22.6582 66.2062 22.7461 66.1697 22.7585 66.1879C22.8453 65.8942 23.086 65.6475 23.2168 65.3865C23.6613 64.496 24.0553 63.4704 24.362 62.523C24.4949 62.1118 24.7239 61.5291 24.8204 61.1484C24.9458 60.6525 24.8809 59.9138 25.164 59.4307V58.0561C25.0782 58.1966 23.8548 59.2383 23.6752 59.316L23.6741 59.3165Z"
          fill="#D592F3"
        />
        <Path
          d="M13.5954 80.3902L14.3969 83.7115C12.9215 83.7147 11.3973 83.5828 9.92993 83.5967L11.0751 80.2755C11.1131 80.2739 11.1512 80.2766 11.1898 80.2755C11.9591 80.2562 12.8496 80.1994 13.5948 80.3902H13.5954Z"
          fill="#585366"
        />
        <Path
          d="M12.6791 53.0171C12.8684 53.0139 13.0624 53.0134 13.2517 53.0171C14.0923 53.0338 14.971 53.2412 15.8288 53.1319C15.876 53.5994 16.0615 54.5097 15.6573 54.7354C15.4669 54.5783 15.7607 54.343 15.5999 54.277C14.3904 53.7838 11.2815 54.7874 9.93045 54.0481C9.91383 53.8851 9.89506 53.1973 9.98781 53.1319C10.8842 53.2386 11.8026 53.0322 12.6791 53.0171Z"
          fill="#3D3D54"
        />
        <Path
          d="M11.0752 80.276L9.93004 83.5973C9.55315 83.601 9.0819 83.7023 8.67017 83.712C9.05188 83.2096 9.97615 80.3076 10.3311 80.1613C10.5873 80.0557 11.0377 80.2771 11.0757 80.276H11.0752Z"
          fill="#88818B"
        />
        <Path
          d="M15.6572 54.7354C15.6218 54.7552 15.0648 54.796 14.8557 54.8501C14.7099 54.8882 14.5303 54.9622 14.5121 54.9649C14.2826 54.9976 13.9904 54.9525 13.8248 54.9649C13.4908 54.9901 13.13 54.9697 12.7938 54.9649C12.3596 54.9584 11.9886 55.0153 11.5339 54.9649C11.4964 54.9606 11.4567 54.9697 11.4192 54.9649C10.5684 54.8491 10.0258 54.9944 9.93042 54.0486C11.2814 54.7885 14.3904 53.7843 15.5999 54.2776C15.7602 54.343 15.4664 54.5789 15.6572 54.7359V54.7354Z"
          fill="#1A1B33"
        />
        <Path
          d="M11.5338 80.0466C11.9664 80.0294 12.48 80.0171 12.9084 80.0466C13.6182 80.0954 13.5528 80.2691 13.5957 80.2755V80.3902C12.85 80.1994 11.96 80.2567 11.1907 80.2755V80.0466C11.418 80.2294 11.3987 80.0519 11.5343 80.0466H11.5338Z"
          fill="#BCA597"
        />
        <Path
          d="M17.0312 83.712C16.1525 83.7174 15.2722 83.7104 14.3967 83.712L13.5952 80.3907V80.276C13.8552 80.3162 14.587 80.3607 14.2825 80.0471C14.3174 80.0567 14.3603 80.0396 14.3972 80.0471C14.6943 80.1077 15.4389 80.1559 15.5424 80.2187C15.7247 80.3296 16.798 83.2847 17.0312 83.712Z"
          fill="#1A1B33"
        />
        <Path
          d="M14.5113 54.9643V55.7658C14.5113 56.1449 14.5268 56.533 14.5113 56.911C14.4335 58.7788 14.5172 60.5555 14.5113 62.4083C14.5075 63.6124 14.3997 64.8546 14.3965 66.0732C14.396 66.3434 14.5113 66.4501 14.5113 66.6458C14.5097 67.4843 14.5113 68.3276 14.5113 69.1655C14.5097 72.4385 14.3965 75.7351 14.3965 79.0151V80.046C14.3601 80.0385 14.3166 80.0557 14.2818 80.046C14.137 80.0048 13.8014 80.1195 13.7092 79.9887L13.824 54.9633C13.9891 54.9509 14.2818 54.996 14.5113 54.9633V54.9643Z"
          fill="#1A264F"
        />
        <Path
          d="M12.7936 54.9643L12.9083 80.0466C12.4799 80.0171 11.9663 80.0294 11.5337 80.0466V54.9643C11.9883 55.0147 12.3593 54.9579 12.7936 54.9643Z"
          fill="#8894BE"
        />
        <Path
          d="M13.824 54.9643L13.7092 79.9897C13.802 80.1205 14.1371 80.0058 14.2818 80.0471C14.5863 80.3607 13.8545 80.3162 13.5945 80.276C13.5516 80.2696 13.617 80.0959 12.9072 80.0471L12.7925 54.9649C13.1286 54.9697 13.4894 54.9901 13.8234 54.9649L13.824 54.9643Z"
          fill="#404D7D"
        />
        <Path
          d="M14.6261 62.5235C14.6047 63.5325 14.6551 64.549 14.6261 65.5585C14.6202 65.7676 14.7409 66.1241 14.3972 66.0737C14.3999 64.8551 14.5082 63.6129 14.5119 62.4088C14.6438 62.3895 14.6111 62.501 14.6267 62.5235H14.6261Z"
          fill="#D592F3"
        />
        <Path
          d="M75.5569 80.6765L75.9981 83.5426H78.5061C78.1544 82.7856 77.5126 80.6819 77.103 80.5044C76.9706 80.447 76.5144 80.5403 76.3015 80.5044C76.205 80.4878 76.2565 80.2766 76.2442 80.2755C76.0775 80.261 76.1568 80.5082 76.0726 80.5044C75.7091 80.4883 75.3483 80.5242 74.9848 80.5044C74.9468 80.5023 74.9082 80.5076 74.8701 80.5044V80.7333C75.1055 80.7644 75.3306 80.7054 75.5574 80.676L75.5569 80.6765Z"
          fill="url(#paint8_linear_8631_20754)"
        />
        <Path
          d="M90.3154 83.5431L88.7853 80.0471C88.5344 80.3521 88.1119 80.0567 87.9264 80.0471C87.8433 80.0428 87.008 80.2792 86.896 80.276L87.6037 83.5431H90.3154Z"
          fill="url(#paint9_linear_8631_20754)"
        />
        <Path
          d="M25.4889 83.7302C25.2723 83.1276 24.6847 80.9038 24.7045 80.7339C24.2242 80.5736 23.4832 80.5666 22.9868 80.6191C22.7938 81.0255 22.1183 83.1657 21.8433 83.6761L25.4889 83.7297V83.7302Z"
          fill="url(#paint10_linear_8631_20754)"
        />
        <Path
          d="M12.81 53.0107C14.6605 53.0107 16.1607 51.5105 16.1607 49.66C16.1607 47.8094 14.6605 46.3092 12.81 46.3092C10.9594 46.3092 9.45923 47.8094 9.45923 49.66C9.45923 51.5105 10.9594 53.0107 12.81 53.0107Z"
          fill="#4665B6"
        />
        <Path
          d="M12.81 46.3092C10.9593 46.3092 9.45923 47.8093 9.45923 49.66C9.45923 50.299 9.63829 50.8957 9.94817 51.404C10.5245 51.872 11.259 52.1529 12.0594 52.1529C13.9101 52.1529 15.4101 50.6529 15.4101 48.8022C15.4101 48.1631 15.2311 47.5664 14.9212 47.0582C14.3449 46.5902 13.6104 46.3092 12.81 46.3092Z"
          fill="url(#paint11_linear_8631_20754)"
        />
        <Path
          d="M11.4964 49.4187C12.207 49.4187 12.7831 48.8426 12.7831 48.132C12.7831 47.4214 12.207 46.8453 11.4964 46.8453C10.7858 46.8453 10.2097 47.4214 10.2097 48.132C10.2097 48.8426 10.7858 49.4187 11.4964 49.4187Z"
          fill="#F5F0FF"
        />
        <Path
          d="M24.497 56.1738C25.7554 56.1738 26.7755 55.1537 26.7755 53.8953C26.7755 52.6369 25.7554 51.6168 24.497 51.6168C23.2386 51.6168 22.2185 52.6369 22.2185 53.8953C22.2185 55.1537 23.2386 56.1738 24.497 56.1738Z"
          fill="#4665B6"
        />
        <Path
          d="M24.497 51.6168C23.2387 51.6168 22.2185 52.637 22.2185 53.8953C22.2185 54.3295 22.3402 54.7354 22.5509 55.0812C22.9428 55.3996 23.4419 55.5905 23.9866 55.5905C25.2449 55.5905 26.2651 54.5703 26.2651 53.312C26.2651 52.8777 26.1434 52.4719 25.9327 52.1261C25.5408 51.8076 25.0417 51.6168 24.497 51.6168Z"
          fill="url(#paint12_linear_8631_20754)"
        />
        <Path
          d="M23.6039 53.7312C24.0872 53.7312 24.4789 53.3395 24.4789 52.8563C24.4789 52.3731 24.0872 51.9814 23.6039 51.9814C23.1207 51.9814 22.729 52.3731 22.729 52.8563C22.729 53.3395 23.1207 53.7312 23.6039 53.7312Z"
          fill="#F5F0FF"
        />
        <Path
          d="M86.4186 53.0107C88.2692 53.0107 89.7693 51.5105 89.7693 49.66C89.7693 47.8094 88.2692 46.3092 86.4186 46.3092C84.568 46.3092 83.0679 47.8094 83.0679 49.66C83.0679 51.5105 84.568 53.0107 86.4186 53.0107Z"
          fill="#4665B6"
        />
        <Path
          d="M86.4186 46.3092C84.5679 46.3092 83.0679 47.8093 83.0679 49.66C83.0679 50.299 83.2469 50.8957 83.5568 51.404C84.1331 51.872 84.8676 52.1529 85.668 52.1529C87.5187 52.1529 89.0188 50.6529 89.0188 48.8022C89.0188 48.1631 88.8397 47.5664 88.5298 47.0582C87.9535 46.5902 87.219 46.3092 86.4186 46.3092Z"
          fill="url(#paint13_linear_8631_20754)"
        />
        <Path
          d="M85.1053 49.4187C85.8159 49.4187 86.392 48.8426 86.392 48.132C86.392 47.4214 85.8159 46.8453 85.1053 46.8453C84.3947 46.8453 83.8186 47.4214 83.8186 48.132C83.8186 48.8426 84.3947 49.4187 85.1053 49.4187Z"
          fill="#F5F0FF"
        />
        <Path
          d="M74.7314 56.1738C75.9898 56.1738 77.0099 55.1537 77.0099 53.8953C77.0099 52.6369 75.9898 51.6168 74.7314 51.6168C73.473 51.6168 72.4529 52.6369 72.4529 53.8953C72.4529 55.1537 73.473 56.1738 74.7314 56.1738Z"
          fill="#4665B6"
        />
        <Path
          d="M74.7314 51.6168C73.4731 51.6168 72.4529 52.637 72.4529 53.8953C72.4529 54.3295 72.5746 54.7354 72.7853 55.0812C73.1772 55.3996 73.6763 55.5905 74.221 55.5905C75.4793 55.5905 76.4995 54.5703 76.4995 53.312C76.4995 52.8777 76.3778 52.4719 76.1671 52.1261C75.7752 51.8076 75.2761 51.6168 74.7314 51.6168Z"
          fill="url(#paint14_linear_8631_20754)"
        />
        <Path
          d="M73.8381 53.7312C74.3213 53.7312 74.713 53.3395 74.713 52.8563C74.713 52.3731 74.3213 51.9814 73.8381 51.9814C73.3549 51.9814 72.9631 52.3731 72.9631 52.8563C72.9631 53.3395 73.3549 53.7312 73.8381 53.7312Z"
          fill="#F5F0FF"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_8631_20754"
            x1="49"
            y1="10"
            x2="49"
            y2="89.087"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEEBF3" />
            <Stop offset="1" stopColor="#B5B2BC" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_8631_20754"
            x1="66.6758"
            y1="10.001"
            x2="66.6758"
            y2="89.089"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#FBF6F6" />
            <Stop offset="1" stopColor="#C4C4C4" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_8631_20754"
            x1="49"
            y1="10"
            x2="49"
            y2="89.087"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEE1E0" />
            <Stop offset="1" stopColor="#C6BAB9" />
          </LinearGradient>
          <LinearGradient
            id="paint3_linear_8631_20754"
            x1="68.5129"
            y1="33.6161"
            x2="54.2596"
            y2="39.4721"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#8A4E8D" />
            <Stop offset="1" stopColor="#A06ABD" />
          </LinearGradient>
          <LinearGradient
            id="paint4_linear_8631_20754"
            x1="72.2035"
            y1="30.4278"
            x2="63.9382"
            y2="33.378"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#5C2F5F" />
            <Stop offset="1" stopColor="#6A3D83" />
          </LinearGradient>
          <LinearGradient
            id="paint5_linear_8631_20754"
            x1="34.4789"
            y1="47.3176"
            x2="22.7465"
            y2="47.6039"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#A37CF1" />
            <Stop offset="1" stopColor="#93AEF9" />
          </LinearGradient>
          <LinearGradient
            id="paint6_linear_8631_20754"
            x1="33.5922"
            y1="47.3043"
            x2="46.4013"
            y2="51.6518"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#97B1F9" />
            <Stop offset="1" stopColor="#7E9EF8" />
          </LinearGradient>
          <LinearGradient
            id="paint7_linear_8631_20754"
            x1="34.3289"
            y1="56.41"
            x2="70.1139"
            y2="61.5866"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#DE77CF" />
            <Stop offset="0.45" stopColor="#A473D7" />
            <Stop offset="1" stopColor="#B2AFEC" />
          </LinearGradient>
          <LinearGradient
            id="paint8_linear_8631_20754"
            x1="74.9034"
            y1="81.6731"
            x2="78.4047"
            y2="82.3529"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#555164" />
            <Stop offset="0.89" stopColor="#161834" />
          </LinearGradient>
          <LinearGradient
            id="paint9_linear_8631_20754"
            x1="86.8997"
            y1="81.5434"
            x2="90.258"
            y2="82.1953"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#555164" />
            <Stop offset="0.89" stopColor="#161834" />
          </LinearGradient>
          <LinearGradient
            id="paint10_linear_8631_20754"
            x1="22.3896"
            y1="82.0248"
            x2="25.4181"
            y2="82.6129"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#555164" />
            <Stop offset="0.89" stopColor="#161834" />
          </LinearGradient>
          <LinearGradient
            id="paint11_linear_8631_20754"
            x1="12.4347"
            y1="46.3092"
            x2="12.4347"
            y2="52.1529"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#5477D6" />
            <Stop offset="0.73" stopColor="#96B1F9" />
          </LinearGradient>
          <LinearGradient
            id="paint12_linear_8631_20754"
            x1="24.2418"
            y1="51.6168"
            x2="24.2418"
            y2="55.5905"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#5477D6" />
            <Stop offset="0.73" stopColor="#96B1F9" />
          </LinearGradient>
          <LinearGradient
            id="paint13_linear_8631_20754"
            x1="86.0433"
            y1="46.3092"
            x2="86.0433"
            y2="52.1529"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#5477D6" />
            <Stop offset="0.73" stopColor="#96B1F9" />
          </LinearGradient>
          <LinearGradient
            id="paint14_linear_8631_20754"
            x1="74.4762"
            y1="51.6168"
            x2="74.4762"
            y2="55.5905"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#5477D6" />
            <Stop offset="0.73" stopColor="#96B1F9" />
          </LinearGradient>
        </Defs>
      </G>
    </AccessibleSvg>
  )
}

export const FirstMuseumBookingUnlocked = styled(FirstMuseumBookingUnlockedSvg).attrs(
  ({ size, theme }) => ({
    size: size ?? theme.illustrations.sizes.medium,
  })
)``
